import React from 'react';
import { Helmet } from 'react-helmet-async';

import { FeatureSwitch } from '@xingternal/feature-switch';

const AdBlockerPlusDetector = () => {
  return (
    <FeatureSwitch flags="xam_abp_tracking">
      <Helmet>
        <script type="text/javascript">var abp;</script>

        <script
          defer
          type="text/javascript"
          src="https://purple-xas.xingassets.com/public-xas-production-s3/abp-detection-public/px.js?ch=1"
        />
        <script
          defer
          type="text/javascript"
          src="https://purple-xas.xingassets.com/public-xas-production-s3/abp-detection-public/px.js?ch=2"
        />
      </Helmet>
    </FeatureSwitch>
  );
};

export default AdBlockerPlusDetector;
